import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { settingsApi } from "../api/resources";
import { useAuth } from "./AuthContext";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);
  const [ready, setReady] = useState(false);

  const reload = useCallback(() => {
    if (!user) return;
    settingsApi.get().then((data) => {
      setSettings(data);
      setReady(true);
    });
  }, [user]);

  useEffect(() => {
    reload();
  }, [reload]);

  return <SettingsContext.Provider value={{ settings, ready, reload }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
